import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Layout from '../views/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { title: '首页', title_en: 'Home' },
    component: Home
  },
  {
    path: '/layout',
    name: '',
    component: Layout,
    redirect: { name: 'Home' },
    children: [
      {
        path: '/about',
        name: 'About',
        meta: { title: '关于中驰', title_en: 'About us', parents: ['Home'] },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      },
      {
        path: '/service',
        name: 'Service',
        meta: { title: '业务领域', title_en: 'Service', parents: ['Home'] },
        component: () => import(/* webpackChunkName: "service" */ '../views/Service.vue')
      },
      {
        path: '/service/:id',
        name: 'ServiceDetail',
        meta: { title: '', title_en: '', parents: ['Home', 'Service'] },
        component: () => import(/* webpackChunkName: "service" */ '../views/ServiceDetail.vue')
      },
      {
        path: '/team',
        name: 'Team',
        meta: { title: '律师团队', title_en: 'Team', parents: ['Home'] },
        component: () => import(/* webpackChunkName: "team" */ '../views/Team.vue')
      },
      {
        path: '/team/:id',
        name: 'TeamDetail',
        meta: { title: '', parents: ['Home', 'Team'] },
        component: () => import(/* webpackChunkName: "team" */ '../views/TeamDetail.vue'),
        props: true
      },
      {
        path: '/activity',
        name: 'Activity',
        meta: { title: '中驰动态', title_en: 'Activity', parents: ['Home'] },
        component: () => import(/* webpackChunkName: "activity" */ '../views/Activity.vue')
      },
      {
        path: '/activity/:id',
        name: 'ActivityDetail',
        meta: { title: '中驰动态', title_en: 'Activity', parents: ['Home', 'Activity'] },
        component: () => import(/* webpackChunkName: "activity" */ '../views/ActivityDetail.vue')
      },
      {
        path: '/invite',
        name: 'Invite',
        meta: { title: '招贤纳士', title_en: 'Invite', parents: ['Home'] },
        component: () => import(/* webpackChunkName: "invite" */ '../views/Invite.vue')
      },
      {
        path: '/contact',
        name: 'Contact',
        meta: { title: '联系我们', title_en: 'Contact', parents: ['Home'] },
        component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue')
      }
    ]
  },
  {
    path: '*',
    redirect: { name: 'Home' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from) {
    return to.name === from.name ? {} : { x: 0, y: 0 }
  }
})

export default router
